module.exports = __webpack_public_path__ + "static/thpcsheepmain-0afc46f899721221cca7a66e96cdfea5.jpeg";